import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useHistory } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getMerchantEcommercePathway,
} from "apiServices/app";
import {
  BasicTheme,
  ExclusiveTheme,
  StandardTheme,
  SuiFrensTheme,
  toastMessage,
  useGlobalMerchant,
} from "utils/helper";
import { CryptoPassword, encryptedText } from "utils/crypto";
import ECBasicComponent from "../ECBasic/ECBasicComponent";
import ECAdvanceComponent from "../ECAdvance/ECAdvanceComponent";
import ECSuiFrensComponent from '../ECSuiFrens/ECSuiFrensComponent';
import ECExclusiveComponent from 'components/Ecommerce/ECTheme/ECExclusive/ECExclusiveComponent';
import { STORE_KEY } from 'utils/env';

const ECThemeComponent = () => {
  const {
    ecommerceContent,
    setGlobalMerchantId,
    setGlobalMerchantCurrency,
    setIsEndsWithSlash,
    setEcommerceContent,
    setThemeName
  } = useGlobalMerchant();
  const managePathname = window.location.pathname;
  const history = useHistory();

  const onErrorRedirect = () => {
    history.push("/404");
    toastMessage("You dont have any profile");
  }

  const onGetEcommerceData = (getUserName: any) => {
    try {
      getMerchantEcommercePathway(getUserName)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            if (responseData && responseData.length > 0) {
              setEcommerceContent(responseData[0]);
              setThemeName(responseData[0].ecom_theme);
              setGlobalMerchantId(responseData[0].merchant_id);
              setGlobalMerchantCurrency(responseData[0].currency);
              localStorage.setItem("ec-email", encryptedText(CryptoPassword, responseData[0].merchant_email));
            } else { onErrorRedirect() }
          }
        })
        .catch((error) => { onErrorRedirect() });
    } catch (error: any) { onErrorRedirect() }
  };

  const renderMainContent = (getThemeName: any) => {
    switch (getThemeName) {
      case BasicTheme: return (
        <ECBasicComponent />
      );
      case StandardTheme: return (
        <ECAdvanceComponent />
      );
      case ExclusiveTheme: return (
        <ECExclusiveComponent />
      );
      case SuiFrensTheme: return (
        <ECSuiFrensComponent />
      );
      default: return (
        <ECAdvanceComponent />
      );
    }
  };

  useEffect(() => {
    try {
      onGetEcommerceData(STORE_KEY)
    } catch (error) { onErrorRedirect() }
  }, [managePathname]);

  return (
    <>
      <ToastContainer />
      {(Object.keys(ecommerceContent).length > 0) ? (
        <>{renderMainContent(ecommerceContent.ecom_theme)}</>
      ) : (
        <div className="loaderCenterWrapper">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      )}
    </>
  );
};

export default ECThemeComponent;
